// extracted by mini-css-extract-plugin
export default {"pile":"characterSymbol_pile__Jm8Vk","symbol":"characterSymbol_symbol__dKRKF","romaji":"characterSymbol_romaji__PVdqb","highlight":"characterSymbol_highlight__hWMdj"};